// src/hooks/usePortfolio.js
import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { isTradingSessionOpen } from '../utils/tradingSession';
//import { elasticSearchService } from '../services/elasticSearchService';

const API_BASE = 'http://localhost:8000';

export const usePortfolio = () => {
  const [portfolio, setPortfolio] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPortfolio = useCallback(async () => {
    setLoading(true);
    setError(null);

    const tradingSessionOpen = isTradingSessionOpen();
    console.log("Trading session open in usePortfolio:", tradingSessionOpen);
    // if (tradingSessionOpen) {
      try {
        // setLoading(true);
        const response = await axios.get(`${API_BASE}/api/portfolio?tdSession=${tradingSessionOpen}`);

        setPortfolio(response.data.portfolio);
        console.log('Portfolio fetched successfully in usePortfolio:', response.data.portfolio);
        // After successful live fetch, save to Elastic Search for future use
        //return response.data.portfolio;
      } catch (err) {
        setError('Failed to fetch portfolio data in usePortfolio');
        console.error('Error:', err);
        setPortfolio([
          { symbol: 'AAPL', name: 'Apple Inc.', quantity: 25, average_cost: 145.32, market_price: 178.21, market_value: 4455.25, unrealized_pnl: 822.25, currency: 'USD' },
          { symbol: 'GOOGL', name: 'Alphabet Inc.', quantity: 10, average_cost: 2350.67, market_price: 2189.43, market_value: 21894.30, unrealized_pnl: -1612.40, currency: 'USD' },
          { symbol: 'TSLA', name: 'Tesla Inc.', quantity: 15, average_cost: 210.45, market_price: 245.67, market_value: 3685.05, unrealized_pnl: 528.30, currency: 'USD' },
          { symbol: 'MSFT', name: 'Microsoft Corp.', quantity: 20, average_cost: 285.12, market_price: 312.89, market_value: 6257.80, unrealized_pnl: 555.40, currency: 'USD' },
          { symbol: 'AMZN', name: 'Amazon.com Inc.', quantity: 8, average_cost: 145.67, market_price: 132.45, market_value: 1059.60, unrealized_pnl: -105.76, currency: 'USD' },
          { symbol: 'NVDA', name: 'NVIDIA Corp.', quantity: 12, average_cost: 345.78, market_price: 412.34, market_value: 4948.08, unrealized_pnl: 798.72, currency: 'USD' },
          { symbol: 'JPM', name: 'JPMorgan Chase', quantity: 30, average_cost: 145.67, market_price: 152.34, market_value: 4570.20, unrealized_pnl: 200.10, currency: 'USD' },
          { symbol: 'V', name: 'Visa Inc.', quantity: 18, average_cost: 234.56, market_price: 221.45, market_value: 3986.10, unrealized_pnl: -235.98, currency: 'USD' },
          { symbol: 'DIS', name: 'Walt Disney Co.', quantity: 25, average_cost: 95.43, market_price: 102.34, market_value: 2558.50, unrealized_pnl: 172.75, currency: 'USD' },
          { symbol: 'NFLX', name: 'Netflix Inc.', quantity: 15, average_cost: 345.67, market_price: 332.45, market_value: 4986.75, unrealized_pnl: -198.30, currency: 'USD' },
          { symbol: 'IBM', name: 'IBM Corp.', quantity: 20, average_cost: 145.67, market_price: 152.34, market_value: 3046.80, unrealized_pnl: 133.40, currency: 'USD' },
          { symbol: 'INTC', name: 'Intel Corp.', quantity: 35, average_cost: 45.67, market_price: 42.34, market_value: 1481.90, unrealized_pnl: -116.55, currency: 'USD' }
        ]);
        throw err;
      } finally {
        setLoading(false);
      }

  }, []);

  const refreshPortfolio = useCallback(() => {
    console.log("Refreshing portfolio... from usePortfolio");
    fetchPortfolio();
  }, [fetchPortfolio]);

  // Initial fetch
  useEffect(() => {
    console.log("Fetching portfolio on mount... from useEffect in userPortfolio");
    fetchPortfolio();
  }, [fetchPortfolio]);  

  return {
    portfolio,
    loading,
    error,
    refreshPortfolio,
    fetchPortfolio
  };
};